import { render, staticRenderFns } from "./TreatmentClassInputForm.vue?vue&type=template&id=3f8e5998&scoped=true&"
import script from "./TreatmentClassInputForm.vue?vue&type=script&lang=js&"
export * from "./TreatmentClassInputForm.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentClassInputForm.vue?vue&type=style&index=0&id=3f8e5998&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8e5998",
  null
  
)

export default component.exports